import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StalkerStore from '../../../store/StalkerStore';
import configs from '../../../configs';

// The backend owns the OAuth flow: /api/xero redirects to Xero, and its callback
// returns the user to /xeroapp with the organisation details pre-filled.
const StepConnectXero = () => {
  const handleConnect = () => {
    try {
      StalkerStore.track('Registration - Connect to Xero', {});
    } catch (e) {
      // Analytics can be blocked by the browser; never let it stop the redirect.
    }
    window.location.assign(configs.xero_auth);
  };

  return (
    <Grid container spacing={2} style={{ padding: '24px' }}>
      <Grid item xs={12} className="ez-text-center">
        <Typography variant="body1" gutterBottom>
          To get started, sign in to Xero and choose the organisation you want to connect to ezyCollect.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          You will come back here to finish your registration.
        </Typography>
      </Grid>
      <Grid item xs={12} className="ez-text-center">
        <Button variant="contained" color="primary" size="large" onClick={handleConnect}>
          Connect to Xero
        </Button>
      </Grid>
    </Grid>
  );
};

export default StepConnectXero;
